function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var HomePage = require('./index');

//
// CRYPTPAD_URL — the origin of the CryptPad instance.
// Update this to match config/config.js httpUnsafeOrigin.
//
var CRYPTPAD_URL = 'https://cryptpad.saito.io';

//
// SAITO_AUTH_RELAY — the relay page on CryptPad's origin that accepts the
// auth fragment, writes to sessionStorage, and redirects to /login.
// Served from CryptPad's customize/saito-auth.html.
//
var SAITO_AUTH_RELAY = "".concat(CRYPTPAD_URL, "/customize/saito-auth.html");
var Docs = /*#__PURE__*/function (_ModTemplate) {
  function Docs(app) {
    var _this;
    _classCallCheck(this, Docs);
    _this = _callSuper(this, Docs, [app]);
    _this.app = app;
    _this.appname = 'Saito Docs';
    _this.name = 'Docs';
    _this.slug = 'docs';
    _this.description = 'End-to-end encrypted collaborative documents, powered by CryptPad';
    _this.categories = 'Utilities Productivity';
    _this.status = 'alpha';
    _this["class"] = 'utility';
    _this.icon = 'fa-solid fa-file-lines';
    _this.styles = ['/docs/style.css'];
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: 'Saito Docs',
      url: '/docs/',
      description: 'End-to-end encrypted collaborative documents on Saito',
      image: '/docs/img/splash.png'
    });

    // Auth state
    _this._authReady = false;
    _this._pubkey = null;
    return _this;
  }

  // ---------------------------------------------------------------------------
  // render() — follows standard Saito module pattern:
  //   1. Create SaitoHeader component (standard nav/wallet)
  //   2. Call super.render() to let framework render header + components
  //   3. Inject our CryptPad iframe below the header
  // ---------------------------------------------------------------------------
  _inherits(Docs, _ModTemplate);
  return _createClass(Docs, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var main;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.browser_active) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (this.header) {
                _context.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.addComponent(this.header);
            case 3:
              _context.n = 4;
              return _superPropGet(Docs, "render", this, 3)([]);
            case 4:
              // Inject the CryptPad iframe container if not already present
              if (!document.getElementById('docs-main')) {
                main = document.createElement('div');
                main.id = 'docs-main';
                main.innerHTML = "\n        <iframe\n          id=\"docs-iframe\"\n          src=\"about:blank\"\n          allow=\"clipboard-read; clipboard-write; fullscreen\"\n          sandbox=\"allow-scripts allow-same-origin allow-forms allow-popups allow-downloads allow-modals allow-top-navigation-by-user-activation\"\n        ></iframe>\n        <div id=\"docs-auth-status\"></div>\n      ";
                document.querySelector('body').appendChild(main);
              }

              // Tap-to-expand for the thin strip header (mobile + desktop click)
              this._attachStripEvents();

              // Start auth flow and load CryptPad
              _context.n = 5;
              return this._initAuth();
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }() // ---------------------------------------------------------------------------
    // Auth handoff
    // ---------------------------------------------------------------------------
  }, {
    key: "_initAuth",
    value: function () {
      var _initAuth2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var privkey, keys, payload, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this._showStatus('Connecting wallet…');
              _context2.p = 1;
              _context2.n = 2;
              return this.app.wallet.getPublicKey();
            case 2:
              this._pubkey = _context2.v;
              _context2.n = 3;
              return this.app.wallet.getPrivateKey();
            case 3:
              privkey = _context2.v;
              if (!(!this._pubkey || !privkey)) {
                _context2.n = 4;
                break;
              }
              this._showStatus('No wallet found — opening CryptPad normally');
              this._loadIframe(CRYPTPAD_URL);
              return _context2.a(2);
            case 4:
              _context2.n = 5;
              return this._deriveKeys(privkey, this._pubkey);
            case 5:
              keys = _context2.v;
              // Encode keys as base64 JSON and pass via the relay page fragment.
              // The fragment is NEVER sent to the server.
              payload = btoa(JSON.stringify(keys)); // Load the relay page. It writes to sessionStorage on cp.hda0.net
              // and redirects to /login automatically.
              this._showStatus('Authenticating…');
              this._loadIframe("".concat(SAITO_AUTH_RELAY, "#").concat(payload));
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              console.error('[Docs] Auth error:', _t);
              this._showStatus('Auth failed — opening CryptPad normally');
              this._loadIframe(CRYPTPAD_URL);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 6]]);
      }));
      function _initAuth() {
        return _initAuth2.apply(this, arguments);
      }
      return _initAuth;
    }() // ---------------------------------------------------------------------------
    // Key material for CryptPad auth handoff.
    //
    // Saito private key format: 128-char hex string = 64 bytes (seed || pubkey).
    // We send the raw 64-byte key as a plain array to the relay page, which
    // stores it in sessionStorage. CryptPad's customize/login.js then derives
    // 192 bytes of deterministic entropy via BLAKE2b (libsodium on CryptPad's
    // origin), bypassing scrypt. Same wallet → same CryptPad identity.
    // ---------------------------------------------------------------------------
  }, {
    key: "_deriveKeys",
    value: function () {
      var _deriveKeys2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(privkeyHex, pubkeyBase58) {
        var privBytes;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              privBytes = new Uint8Array(privkeyHex.match(/.{1,2}/g).map(function (b) {
                return parseInt(b, 16);
              }));
              return _context3.a(2, {
                signingKey: Array.from(privBytes),
                // Ed25519 secret key (64 bytes) as plain array
                publicKey: pubkeyBase58 // Saito base58 public key (for username derivation)
              });
          }
        }, _callee3);
      }));
      function _deriveKeys(_x, _x2) {
        return _deriveKeys2.apply(this, arguments);
      }
      return _deriveKeys;
    }() // ---------------------------------------------------------------------------
    // iframe management
    // ---------------------------------------------------------------------------
  }, {
    key: "_loadIframe",
    value: function _loadIframe(url) {
      var _this2 = this;
      var iframe = document.getElementById('docs-iframe');
      if (!iframe) return;
      iframe.addEventListener('load', function () {
        _this2._hideStatus();
      }, {
        once: true
      });
      iframe.src = url;
    }

    // ---------------------------------------------------------------------------
    // Strip header — tap/click to expand on touch devices
    // ---------------------------------------------------------------------------
  }, {
    key: "_attachStripEvents",
    value: function _attachStripEvents() {
      var header = document.getElementById('saito-header');
      if (!header || header._docsEventsAttached) return;
      header._docsEventsAttached = true;
      header.addEventListener('click', function (e) {
        // Toggle expanded state on click (for touch devices where hover doesn't work)
        if (!header.classList.contains('docs-expanded')) {
          header.classList.add('docs-expanded');
        } else if (e.target === header || e.target.closest('#saito-header') === header) {
          // Click on the header itself (not inner controls) collapses it
          header.classList.remove('docs-expanded');
        }
      });

      // Click outside header collapses it
      document.addEventListener('click', function (e) {
        if (!e.target.closest('#saito-header') && !e.target.closest('.saito-header-hamburger-contents')) {
          header.classList.remove('docs-expanded');
        }
      });
    }

    // ---------------------------------------------------------------------------
    // Status toast
    // ---------------------------------------------------------------------------
  }, {
    key: "_showStatus",
    value: function _showStatus(msg) {
      var el = document.getElementById('docs-auth-status');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('visible');
    }
  }, {
    key: "_hideStatus",
    value: function _hideStatus() {
      var el = document.getElementById('docs-auth-status');
      if (!el) return;
      el.classList.remove('visible');
    }

    // ---------------------------------------------------------------------------
    // webServer — serve the HTML page + static assets
    //
    // modtemplate.webServer only serves static OR HTML, not both.
    // We need both: static assets from web/ (CSS, images) AND the HTML shell.
    // Same pattern as RedSquare, Vault, Stack.
    // ---------------------------------------------------------------------------
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/web");
      var slug = encodeURI(this.returnSlug());
      var mod_self = this;

      // 1. Static assets from web/ FIRST, but with redirect disabled
      //    so express.static doesn't redirect /docs → /docs/ for the directory
      expressapp.use('/' + slug, express["static"](webdir, {
        redirect: false
      }));

      // 2. HTML page at /docs and /docs/
      expressapp.get(['/' + slug, '/' + slug + '/'], function (req, res) {
        var html = HomePage(app, mod_self, app.build_number, mod_self.social || {});
        if (!res.finished) {
          res.setHeader('Content-type', 'text/html');
          res.charset = 'UTF-8';
          return res.send(html);
        }
      });
    }

    // ---------------------------------------------------------------------------
    // respondTo — register "Docs" in the Saito header nav on other pages
    // ---------------------------------------------------------------------------
    /*
    respondTo(type) {
      if (type === 'saito-header') {
        return [
          {
            text: 'Docs',
            icon: this.icon,
            rank: 60,
            type: 'module',
            navigation: true,
            callback: (app) => {
              window.location = '/docs';
            },
          },
        ];
      }
      return super.respondTo(type);
    }
    */
  }]);
}(ModTemplate);
module.exports = Docs;